import { styled } from '@mui/material/styles';
import { Autocomplete, Box } from '@mui/material';
import { OptionType } from '../CustomAutocomplete';

export const StyledAutocomplete = styled(
  Autocomplete<OptionType, boolean, false, false>,
)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    padding: 11,
    fontSize: 12, 
    fontWeight: 500,
    lineHeight: '16px',
    fontFamily: theme.typography.fontFamily,
    paddingRight: '13px !important',
    textTransform: 'capitalize',
    borderRadius: 8,
    '& fieldset': {
      borderColor: theme.palette.divider,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
  '& .MuiInputBase-input': {
    color: theme.palette.text.tertiary,
    padding: '0 !important',
  },
  '& .MuiAutocomplete-tag': {
    backgroundColor: theme.palette.background.tertiary,
    color: theme.palette.text.primary,
    fontWeight: 400,
    borderRadius: 6,
    '& .MuiChip-deleteIcon': {
      width: 14,
      color: theme.palette.text.primary,
      '&:hover': {
        color: theme.palette.error.main,
      },
    },
  },
  '& .MuiChip-root': {
    height: 24,
    '& .MuiChip-label': {
      fontSize: 12,
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
  },
  '& .MuiAutocomplete-option': {
    '&[aria-selected="true"]': {
      backgroundColor: `${theme.palette.primary.main}14`,
    },
    '&.Mui-focused': {
      backgroundColor: `${theme.palette.primary.main}14`,
    },
  },
}));


export const StyledTagBox = styled(Box)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 700,
  color: theme.palette.text.primary,
}));
